



import { ICanvasElementDrawArgs } from '@/models/marketingCenter/canvas';
import {
  IMarketingCenterFormat,
  EMarketingCenterFormats
} from '@/models/marketingCenter/format';
import { IMarketingCenterPost } from '@/models/marketingCenter/post';
import { render } from '@/models/marketingCenter/template';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({})
export default class MarketingCenterCanvasPreview extends Vue {
  @Prop({ required: true }) post!: IMarketingCenterPost;
  @Prop({ required: true }) format!: EMarketingCenterFormats;
  @Prop({ required: true }) ctx!: CanvasRenderingContext2D;
  @Prop({ required: true }) drawArgs!: ICanvasElementDrawArgs;
  @Prop({ required: true }) width!: number;
  @Prop({ required: true }) height!: number;
  @Prop({ default: 0 }) refreshState!: number;

  formatData = {} as IMarketingCenterFormat;

  clear() {
    this.container.innerHTML = '';
  }

  update() {
    this.clear();
    render(
      this.container,
      this.ctx,
      this.post.template,
      this.format,
      this.drawArgs
    );
  }

  @Watch('refreshState')
  onFormatChange() {
    // Wait for canvas format change
    window.requestAnimationFrame(() => {
      const newFormat = this.post.template.formats.find(
        format => format.key === this.format
      );

      if (newFormat) {
        this.formatData = newFormat;
        this.update();
      }
    });
  }

  @Watch('post')
  onPostChange() {
    this.update();
  }

  mounted() {
    window.requestAnimationFrame(() => {
      this.update();
    });
  }

  get style() {
    let style = `
      width: ${this.width}px;
      height: ${this.height}px;
    `;

    if (this.formatData && this.formatData.renderScale) {
      style += `transform: scale(${this.formatData.renderScale})`;
    }

    return style;
  }

  get container() {
    return this.$refs.container as HTMLDivElement;
  }
}
